/* global VXConfig */
import React            from 'react';
import PropTypes        from 'prop-types';
import Translations     from '../../utils/Translations';
import Flux             from '../../flux/Flux';

const MIN_SUGGESTIONS_PATTERN_LENGTH = 2;
class TagSuggest extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			tags: '',
			touched: false,
			clickedTag: false,
			showSuggestBtn: true,
			isToggleOn: true,
			existTags: [],
			existTagsCache: [],
			selectedTags: [],
			showConfirmation: false,
		};
		this.inputField = null;
	}

	recommendVideos() {
		Flux.Vxql.addTagToAlbum(this.props.albumId, this.state.selectedTags.map(t => t.id), () => {
			this.setState({
				showConfirmation: true,
			});
		});
		this.clear();
	}

	handleSubmit(value) {
		Flux.Tags.searchTags(value, (data) => {
			const existTags = data.data.tagSearch.tags;
			this.setState({
				existTags: existTags.filter(e => !this.state.selectedTags.map(s => s.label).includes(e.label)),
				existTagsCache: existTags,
				touched: true,
			});
		});
	}

	handleChange(e) {
		const value = e.target.value;
		this.setState({tags: value}, () => {
			const tags = this.state.tags;
			if(tags.length >= MIN_SUGGESTIONS_PATTERN_LENGTH){
				this.handleSubmit(tags);
			}
			else {
				this.setState({existTags: []});
			}
		});

	}

	onTagSelected(tag) {
		let selectedTags = this.state.selectedTags;
		if(selectedTags.length < 10) {
			selectedTags.push(this.state.existTagsCache.find(v => v === tag));
		}
		selectedTags = [...new Set(selectedTags)];
		this.setState({
			clickedTag:   true,
			selectedTags: selectedTags,
			existTags:    this.state.existTags.filter(ex => !selectedTags.includes(ex)),
		});
	}

	onTagClose(tag){
		const selectedTags = this.state.selectedTags.filter(s => s !== tag);
		this.setState({
			selectedTags: selectedTags,
			existTags:    this.state.existTagsCache.filter(ex => !selectedTags.includes(ex)),
		});
	}

	clear(){
		this.inputField.value = '';
		this.setState({
			tags: '',
			isToggleOn: !this.state.isToggleOn,
			existTags: [],
		});
	}

	render() {
		const InputField = (className) => (
			<input type="text"
			       className={className}
			       placeholder={Translations.get('addNewTag')}
			       ref={ref => this.inputField = ref}
			       onChange={(e) => this.handleChange(e)}
			       value={this.state.tags}>
			</input>
		);
		if(this.state.isToggleOn){
			const foundedTags = this.state.existTags.filter(v => v.label.toString().toLowerCase().startsWith(this.state.tags.toString().toLowerCase())); // TODO rename tags variable in state
			return (
				<div className="profile-videos-tag-suggestion">
					{this.state.clickedTag ? this.state.selectedTags.map(tag => (<div className={VXConfig.device.isMobile ? "actor-pictures__tag badge--filter" : "profile-videos-tag-suggestion__container__item"}>{tag.label}<img className="actor-pictures__tag--close" onClick={() => this.onTagClose(tag)} src="/assets/img/close-full.svg" /></div>)) : ''}
					{VXConfig.device.isMobile ?
						<div>
							{InputField("profile-videos-tag-suggestion__input")}
						</div> :
						<div>{InputField("profile-videos-tag-suggestion__input--desktop")}<div className={this.state.selectedTags.length > 0 ? "profile-videos-tag-suggestion__button--desktop" : "profile-videos-tag-suggestion__button--desktop--disabled"} onClick={() => this.recommendVideos()}>{Translations.get('suggestButton')}</div></div>}

					{!this.state.touched || this.state.selectedTags.length > 0 ? <div className="profile-videos-tag-suggestion__wrapper__text">
						<span className="">{Translations.get('numberOfChar')}</span>
					</div> : ''}
					<div className="profile-videos-tag-suggestion__container">
						{
							this.state.touched ? (foundedTags.length > 0 ?
								foundedTags.map(tag => (<div className={VXConfig.device.isMobile ? "actor-pictures__tag badge--filter" : "profile-videos-tag-suggestion__container__item"} onClick={() => this.onTagSelected(tag)}>{tag.label}</div>))
								: <div className="profile-videos-tag-suggestion__notfound"><span className="profile-videos-tag-suggestion__notfound--big">{Translations.get('notFoundText')}</span><div className="profile-videos-tag-suggestion__notfound--small">{Translations.get('notFound')}</div></div>) : ''
						}
					</div>
					{!this.state.touched || this.state.selectedTags.length > 0 ?
						<div className="profile-videos-tag-suggestion__wrapper">
							{(this.state.showSuggestBtn && VXConfig.device.isMobile) && <div className={this.state.selectedTags.length > 0 ? "profile-videos-tag-suggestion__wrapper__button" : "profile-videos-tag-suggestion__wrapper__button--disabled"} onClick={() => this.recommendVideos()}>{Translations.get('suggestButton')}</div>}
						</div>
						: ''
					}

				</div>
			);
		}
		return (
			<div>{this.state.showConfirmation ?
				<div className="profile-videos-tag-suggestion-footer">
					<div className="profile-videos-tag-suggestion-footer__text--icon">
						<img src="/assets/img/success-rounded-full.svg" />
					</div>
					<span className="profile-videos-tag-suggestion-text--footer">{Translations.get('sentTagsSuggest')}</span>
				</div> : ''}
			</div>
		);
	}
}

TagSuggest.propTypes = {
	albumId:         PropTypes.albumId,
	searchText:      PropTypes.string,
	isMobile:        PropTypes.bool,
};

TagSuggest.defaultProps = {
	searchText:      '',
	isMobile:        false,
};

export default TagSuggest;